import { FC } from 'react'
import { TipoReceitaSncr } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { StatusDot, StatusDotTone } from 'app/components'

/** Tom por tipo, só para distinguir no olho; o texto carrega o significado. */
export const TOM_TIPO_RECEITA: Record<TipoReceitaSncr, StatusDotTone> = {
  [TipoReceitaSncr.RCE]: 'dark',
  [TipoReceitaSncr.RET]: 'danger',
  [TipoReceitaSncr.NRA]: 'dark',
  [TipoReceitaSncr.NRB]: 'dark',
  [TipoReceitaSncr.NRB2]: 'dark',
  [TipoReceitaSncr.NRR]: 'dark',
}

/**
 * O que cada tipo cobre (Portaria 344): RCE é a receita branca de duas vias das listas C1/C5;
 * RET é a receita retida na farmácia (antimicrobianos). Os tarja preta (listas A e B) e os
 * retinoides são Notificação de Receita, numerada em avulso.
 */
export const CHAVE_DESCRICAO_TIPO_RECEITA: Record<TipoReceitaSncr, string> = {
  [TipoReceitaSncr.RCE]: 'sncr.tipo.rce_descricao',
  [TipoReceitaSncr.RET]: 'sncr.tipo.ret_descricao',
  [TipoReceitaSncr.NRA]: 'sncr.tipo.nra_descricao',
  [TipoReceitaSncr.NRB]: 'sncr.tipo.nrb_descricao',
  [TipoReceitaSncr.NRB2]: 'sncr.tipo.nrb2_descricao',
  [TipoReceitaSncr.NRR]: 'sncr.tipo.nrr_descricao',
}

type IProps = {
  tipo: TipoReceitaSncr
}

/** Sigla do tipo com o ponto de cor. */
export const SncrTipoReceitaDot: FC<IProps> = ({ tipo }) => (
  <StatusDot label={tipo} tone={TOM_TIPO_RECEITA[tipo]} />
)

/** Descrição curta do que o tipo cobre, para acompanhar a sigla onde há espaço. */
export const SncrTipoDescricao: FC<IProps> = ({ tipo }) => {
  const { t } = useT()
  return <>{t(CHAVE_DESCRICAO_TIPO_RECEITA[tipo])}</>
}
